import React, { useState } from 'react'
import "./TabView.css"

function TabView({data}) {
    const [viewData, setViewData] = useState("Info")

    
  return (
    <div className='modalViewDiv tabview_outer_div'>
        <div className='tabView_tabs'>
            {Object.keys(data).map((title) => (
                <p onClick={() => setViewData(title)} className={title === viewData ? "tabView_tabs_selected" : ""}>{title}</p>
            ))}
        </div>

        <div className='tabView_description'>
            {viewData === "Facts" && 
                <p className='tabView_desc_facts'>
                    {data["Facts"].fact.map(i => (
                        <li>{i}</li>
                    ))}
                </p>
            }

            {viewData === "Source" && 
                <div className='tabView_desc_image'>
                    {data["Source"].images.map(i => (
                        <img
                            src={i.includes("image/") ? require(`../${i}`) : i}
                            alt={i}
                        />
                    ))}
                </div>
            }
            {(viewData !== "Facts" && viewData !== "Source") && 
                <table>
                    {Object.keys(data[viewData]).map(detail => (
                        <tr>
                            <td className='tabView_data tabView_keys'>{detail}: </td>
                            <td className='tabView_data tabView_value'>{data[viewData][detail]}</td>
                        </tr>
                    ))}
                </table>
            }
                
            
        </div>
    </div>
  )
}

export default TabView